import React from 'react'
import { useIntl } from 'react-intl'
import { useConfig } from 'msp-integrations'
import { Icons } from '../../../index'

const CartUSPLabel = ({
  message,
  className
}: {
  message: string
  className?: string
}) => (
  <div className='flex flex-row items-center space-x-2'>
    <Icons iconName='Confirmation' size='xl' />
    <span className={className || ''}>{message}</span>
  </div>
)

const CartUSP = () => {
  const { formatMessage } = useIntl()
  const {
    theme: {
      font: { regular: fontRegular }
    }
  } = useConfig()

  const uspLabels = [
    formatMessage({
      id: 'msp.cart.usp.label.1',
      defaultMessage: 'Secure Payment'
    }),
    formatMessage({
      id: 'msp.cart.usp.label.2',
      defaultMessage: 'Free Return'
    }),
    formatMessage({
      id: 'msp.cart.usp.label.3',
      defaultMessage: '24 h Support'
    })
  ]

  return (
    <div className='checkout-left flex flex-col items-center justify-center space-y-3 bg-white  py-5 md:flex-row md:justify-around md:space-y-0'>
      {uspLabels?.map((uspLabel: any, ind: number) => (
        <CartUSPLabel
          key={`cartUSPLabel_${ind}`}
          className={`${fontRegular} text-14 tracking-0 min-w-[200px] uppercase md:min-w-fit`}
          message={uspLabel}
        />
      ))}
    </div>
  )
}

export default CartUSP
